import styles from '../style/projects.module.css';
import { publicAsset } from '../utils/publicAsset';

function linkLabel(copy, project) {
  if (project.siteCta === 'app') return copy.openApp;
  if (project.site) return copy.openSite;
  return copy.viewCode;
}

export default function ProjectShowcase({ project, language, ui }) {
  const synopsisKey = `synopsis${language.toUpperCase()}`;
  const categoryKey = `category${language.toUpperCase()}`;
  const imageAltKey = `imageAlt${language.toUpperCase()}`;
  const alt = project[imageAltKey] || project.title;

  return (
    <article className={ `${styles.showcase} ${styles.cardElevated}` }>
      <div className={ styles.showcaseMedia }>
        <img
          src={ publicAsset(project.image) }
          alt={ alt }
          className={ styles.showcaseImage }
          loading="lazy"
        />
      </div>
      <div className={ styles.showcaseBody }>
        <div className={ styles.showcaseHeader }>
          <span className={ styles.categoryPill }>{project[categoryKey]}</span>
          <h2 className={ styles.showcaseTitle }>{project.title}</h2>
        </div>
        <p className={ styles.showcaseDescription }>{project[synopsisKey]}</p>
        <div className={ styles.techCloud }>
          {project.technologies.map((technology) => (
            <span key={ technology } className={ styles.techChip }>
              {technology}
            </span>
          ))}
        </div>
        {(project.site || project.github) && (
          <div className={ styles.actionRow }>
            {project.site && (
              <a
                className={ styles.btnPrimary }
                href={ project.site }
                target="_blank"
                rel="noreferrer"
              >
                {linkLabel(ui, project)}
              </a>
            )}
            {project.github && (
              <a
                className={ styles.btnGhost }
                href={ project.github }
                target="_blank"
                rel="noreferrer"
              >
                <img src={ publicAsset('/github_gray.svg') } alt="" className={ styles.btnIcon } />
                {ui.viewCode}
              </a>
            )}
          </div>
        )}
      </div>
    </article>
  );
}
